export const safeParse = (json) => {
  try {
    return JSON.parse(json);
  } catch {
    return null;
  }
};
